// AI Generated: RTK Query API slice for Home page
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const homeApiSlice = createApi({
  reducerPath: 'homeApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/bo/api' }),
  endpoints: (builder) => ({
    getHomeStats: builder.query({
      query: () => ({
        url: '/homeStats',
        method: 'GET',
      }),
      transformResponse: (res: any) => {
        return res.data;
      },
      keepUnusedDataFor: 300, // Cache for 5 minutes
    }),

    getTestimonials: builder.query({
      query: () => ({
        url: '/testimonials',
        method: 'GET',
      }),
      transformResponse: (res: any) => {
        return res.data;
      },
      keepUnusedDataFor: 300,
    }),
  }),
});

export const {
  useGetHomeStatsQuery,
  useLazyGetHomeStatsQuery,
  useGetTestimonialsQuery,
  useLazyGetTestimonialsQuery,
} = homeApiSlice;
// AI Generated: End of home API slice




